import { useCallback, useEffect, useState } from 'react';
import { collectDeliveries, createDelivery, opsErr, okCode } from '../../api/ops';
import { useToast } from '../../components/Toast';
import { useModal } from '../../components/ModalProvider';
import { OpsGate, useOps, daysAgo, toInputDate, inputToDmy, fmtMoney } from './opsCommon';

// NHẬN ĐƠN GIAO (app "i love GTS"): chọn các đơn đã đóng gói chờ giao -> tạo BẢNG KÊ giao cho chính mình
// (POST /api/delivery, delivery_type DR).
const addr = (it) => [it.address, it.ward, it.district, it.province].filter(Boolean).join(', ');

function ConfirmBatch({ items, onRemove, onSubmit, onClose }) {
  const [busy, setBusy] = useState(false);
  return (
    <div>
      <h3>Xác nhận nhận {items.length} đơn</h3>
      <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
        {items.map((it) => (
          <div key={it.code} className="checkrow">
            <div className="meta">
              <div className="nm">{it.code}</div>
              <div className="dt">{it.quality} kiện · {it.weight} kg · {addr(it)}</div>
            </div>
            <button className="btn xs ghost" onClick={() => onRemove(it.code)} title="Bỏ">×</button>
          </div>
        ))}
      </div>
      <div className="row" style={{ justifyContent: 'flex-end', marginTop: 12 }}>
        <button className="btn ghost" onClick={onClose}>Hủy</button>
        <button className="btn" disabled={!items.length || busy} onClick={async () => { setBusy(true); await onSubmit(); setBusy(false); }}>
          {busy ? 'Đang tạo…' : 'Xác nhận'}
        </button>
      </div>
    </div>
  );
}

function Collect() {
  const account = useOps();
  const toast = useToast();
  const { openModal, closeModal } = useModal();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sel, setSel] = useState([]); // mã đơn theo thứ tự chọn (= position trong bảng kê)

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await collectDeliveries({ from: inputToDmy(toInputDate(daysAgo(360))), to: inputToDmy(toInputDate(new Date())) });
      setItems(okCode(d) ? d.data || [] : []);
    } catch (e) {
      toast(opsErr(e, 'Không tải được danh sách đơn'), 'danger');
    } finally {
      setLoading(false);
    }
  }, [toast]);
  useEffect(() => { load(); }, [load]);

  const toggle = (code) => setSel((p) => (p.includes(code) ? p.filter((c) => c !== code) : [...p, code]));
  const allSel = items.length > 0 && sel.length === items.length;

  const submit = async (codes) => {
    const chosen = codes.map((c) => items.find((i) => i.code === c)).filter(Boolean);
    try {
      const d = await createDelivery({
        pieces: chosen.reduce((s, i) => s + (Number(i.quality) || 0), 0),
        batch_code: '',
        delivery_mode: 'A',
        delivery_type: 'DR',
        packages: {},
        length: chosen.length,
        shipments: chosen.map((i, idx) => ({ code: i.code, quality: i.quality, position: idx + 1 })),
        staff_id: account.sxUserId,
        weight: chosen.reduce((s, i) => s + (Number(i.weight) || 0), 0),
      });
      if (okCode(d)) {
        toast('Tạo bảng kê thành công');
        closeModal();
        setSel([]);
        load();
      } else toast(d?.message || 'Lỗi khi tạo bảng kê', 'danger');
    } catch (e) {
      toast(opsErr(e, 'Lỗi khi tạo bảng kê'), 'danger');
    }
  };

  const openConfirm = () => {
    let codes = [...sel];
    const render = () => openModal(
      <ConfirmBatch
        items={codes.map((c) => items.find((i) => i.code === c)).filter(Boolean)}
        onRemove={(c) => { codes = codes.filter((x) => x !== c); setSel(codes); render(); }}
        onSubmit={() => submit(codes)}
        onClose={closeModal}
      />
    );
    render();
  };

  return (
    <>
      <div className="row between" style={{ marginBottom: 10 }}>
        <span className="small">Có <b>{items.length}</b> đơn chờ nhận</span>
        <div className="row">
          <button className="btn sm ghost" onClick={load} title="Tải lại"><i className="ti ti-refresh" /></button>
          <label className="small row" style={{ gap: 6 }}>
            <input type="checkbox" checked={allSel} onChange={() => setSel(allSel ? [] : items.map((i) => i.code))} /> Chọn tất cả
          </label>
        </div>
      </div>
      {loading ? <div className="empty">Đang tải…</div> : !items.length ? <div className="empty">Không có đơn chờ nhận.</div> : (
        <div className="ops-list">
          {items.map((it) => (
            <label key={it._id || it.code} className="card ops-item ops-check">
              <input type="checkbox" checked={sel.includes(it.code)} onChange={() => toggle(it.code)} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="row between"><b>{it.code}</b><span className="small">{it.quality} kiện · {it.weight} kg</span></div>
                {it.name && <div className="small">{it.name}{it.phone ? ` · ${it.phone}` : ''}</div>}
                <div className="small muted">{addr(it)}</div>
                {Number(it.cod) > 0 && <div className="small">COD: <b>{fmtMoney(it.cod)} đ</b></div>}
              </div>
            </label>
          ))}
        </div>
      )}
      <div className="ops-footer">
        <button className="btn" style={{ width: '100%' }} disabled={!sel.length} onClick={openConfirm}>Xác nhận ({sel.length})</button>
      </div>
    </>
  );
}

export default function OpsCollectPage({ onBack }) {
  return (
    <OpsGate onBack={onBack} title="Nhận đơn giao" sub="Chọn đơn đã đóng gói để tạo bảng kê giao hàng">
      <Collect />
    </OpsGate>
  );
}
